module.exports = __webpack_public_path__ + "img/video_tang_1.0537a0a3.jpg";